import { Component, OnInit } from '@angular/core';
import { DashboarduiService } from '../../Shared/Service/dashboardui.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { interval } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Item } from 'angular2-multiselect-dropdown';

@Component({
  selector: 'app-newfnpipeactions',
  templateUrl: './newfnpipeactions.component.html',
  styleUrls: ['./newfnpipeactions.component.css']
})
export class NewfnpipeactionsComponent implements OnInit {
  Userid: any = [];
  actions: string[];
  selectedAction: string;
  apiresult: any;
  hotellist: any = [];
  lstgetcmlist:any[];
  dropdownDeptData: any;
  ColumnHeader: boolean;
  hotellistChannel: any[];
  singleSelection: false;  // Allow multiple selection
  enableCheckAll: true;
  closeDropDownOnSelection: false;
  hotellistproperty: any;
  isProgressing: Boolean = false;
  dropdownSettingsDept: IDropdownSettings = {};
  //selectedDeptItems: any;
  selectedDeptItems: any[] = [];
  searchBarFilter: boolean = false;
  public Pmscodevalue: any;
  searchText = "";
  errorMessage: string;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  addBtnDisabledFunc: boolean = true;
  hotelSearchDataStatus: any;
  heartBeatData: any;
  excelFunction: boolean = false;
  productType: any;
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  filterProperty: any
  isSaveEnabled = false;
  dataSource: any[] = []; // Data for the table 
  selectedCodes:any;
  displayedColumns: string[] = ['pmscode', 'actionname', 'crby', 'crdt'];
  constructor(private apiCallIdsService: DashboarduiService,private toastr: ToastrService ) {   
    
    this.actions = ['Patch Installation', 'Restart FN New Service', 'Windows Scheduler Creation','Inventory Refill','SQL Script'];
    this.selectedAction = this.actions[0];}
    ngOnInit() {
      if (this.selectedAction) {
        this.newfnpipeactionReadlog();
      }
      this.callIDSUsersProperties();
      this.dropdownSettingsDept = {
        idField: 'pmscode',
        textField: 'pmsname',
        allowSearchFilter: true,
        singleSelection: false, // Enable multiple selection
        enableCheckAll: true,   // Add "Select All" option
        closeDropDownOnSelection: false, // Keep dropdown open after selection
        itemsShowLimit: 7,
        noDataAvailablePlaceholderText: 'No Data Found',
        searchPlaceholderText: "Search Hotel Code / Name"
      }; 
      console.log('Component Initialized');
    }
    public onActionChange(action: string): void {
      this.selectedAction = action;
      console.log(`Selected Action: ${this.selectedAction}`);
      this.updateSaveButtonStatus();
      this.newfnpipeactionReadlog();
    }
    callIDSUsersProperties() {
      this.Userid = localStorage.getItem("Username");
      console.log(this.Userid)
      this.apiCallIdsService.newfnpipeactionsgetproperties()
        .subscribe(
          data => {
            console.log('New Screen Data', data)
            this.apiresult = data;
            this.hotellistproperty = this.apiresult;
            this.dropdownDeptData = this.apiresult;
            this.isProgressing = false;
          });
    }
    onSelectionChange(event: any) {
      console.log('Selected PMS Codes:', this.selectedDeptItems);
      this.updateSaveButtonStatus();
      this.newfnpipeactionReadlog();
    }
    changePropertySearch() {
      if (this.selectedDeptItems) {
        this.searchBarFilter = false;
        this.searchText = '';
        if (this.selectedDeptItems.length > 0) {
          this.Pmscodevalue = this.selectedDeptItems.map(item => item.pmscode).join(',');
          console.log('PMS Codes Selected:', this.Pmscodevalue);
          
          this.errorMsgSubscription = true;
          this.errorMessage = "Please select property and load";
          this.displayContent = false;
          this.addBtnDisabledFunc = false;
  
          // Handle PMS code status and heartbeat for each selected PMS code
          this.selectedDeptItems.forEach(item => {
            this.apiCallIdsService.readHotelSearch(item.pmscode).subscribe((data) => {
              console.log('Hotel Search Data for PMS Code:', item.pmscode, data);
              this.hotelSearchDataStatus = data[0].recordstatus;
              this.productType = data[0].producttype;
            });
  
            this.apiCallIdsService.readHeartbeat(item.pmscode).subscribe((data) => {
              console.log('Heartbeat Data for PMS Code:', item.pmscode, data);
              this.heartBeatData = data[0].heartBeat;
  
              const today = new Date();
              this.currentDateStore = today.toLocaleTimeString('it-IT');
              this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData);
              var start = this.storeHeartBeatValue.split(":");
              var end = this.currentDateStore.split(":");
              var startDate = new Date(0, 0, 0, start[0], start[1], 0);
              var endDate = new Date(0, 0, 0, end[0], end[1], 0);
              var diff = endDate.getTime() - startDate.getTime();
              var hours = Math.floor(diff / 1000 / 60 / 60);
              diff -= hours * 1000 * 60 * 60;
              var minutes = Math.floor(diff / 1000 / 60);
  
              if ((hours + ":" + minutes) > "0:30") {
                this.blinkOfflineHotel = true;
              } else {
                this.blinkOfflineHotel = false;
              }
            });
          });
        } else {
          this.errorMsgSubscription = true;
          this.errorMessage = "Please select property and load";
          this.displayContent = false;
          this.addBtnDisabledFunc = true;
          this.excelFunction = false;
        }
      } else {
        console.log('Property Not Selected');
      }
    }
       /*  onPmsCodeChange(event: any) {
 this.selectedCodes = this.selectedDeptItems.map(item => item.pmscode);
      console.log("SELETEDPMSOCDE",this.selectedCodes)
  if (this.selectedCodes.length > 0) {
    this.dataSource = this.selectedDeptItems.filter(item =>
      this.selectedCodes.includes(item.pmscode)
    );
  } else {
    this.dataSource = [this.selectedDeptItems];
  }
} */
    readnewfnpipeaction() {
      if (this.selectedAction === "Patch Installation") {
        this.selectedAction = "Patchinstallation";
      } else if (this.selectedAction === "Restart FN New Service") {
        this.selectedAction = "RestartFNNewService";
      } else if (this.selectedAction === "Windows Scheduler Creation") {
        this.selectedAction = "WindowsSchedulerCreation";
      }else if (this.selectedAction === "Inventory Refill") {
        this.selectedAction = "InventoryRefill";
      }else if (this.selectedAction==="SQL Script")
      {
        this.selectedAction="SQLScript"
      }
      if (this.selectedDeptItems.length > 0) {
        this.selectedDeptItems.forEach(item => {
          this.apiCallIdsService.newfnpipeactionsread(item.pmscode, this.selectedAction,this.Userid)
            .subscribe(response => {
              console.log('API Response for PMS Code:', item.pmscode, response);
              if (response[0].status === 'Success') {
                this.toastr.success(response[0].statusDescription);
                //this.newfnpipeactionsavelog();
              }
              else
              {
                this.toastr.error(response[0].statusDescription);
              }
            });
        });
      } else {
        console.error('No PMS Code selected');
      }
    }
    onSaveButtonClick()
    {
      this.newfnpipeactionsavelog();
      // Then, trigger the read data API
      this.readnewfnpipeaction();
    }

    newfnpipeactionsavelog() {
      this.isProgressing = true;
    
      const pmsCodesCsv = this.selectedDeptItems.map(item => item.pmscode).join(',');
      console.log("comma pmscode", pmsCodesCsv);
    
      if (this.selectedDeptItems.length > 0) {
        // Call the API once with the concatenated `pmsCodesCsv`
        this.apiCallIdsService.newfnpipeactionloadreadsave(pmsCodesCsv, this.selectedAction, '', this.Userid, "Save")
          .subscribe(
            data => {
              console.log('New Screen Data Log Save', data);
              this.dataSource = data;
              this.hotellistproperty = this.apiresult;
              this.dropdownDeptData = this.apiresult;
              this.isProgressing = false;
              this.displayContent = true;
            },
            error => {
              console.error('Error saving data:', error);
              this.isProgressing = false; // Ensure the progress indicator is reset in case of error
            }
          );
      } else {
        console.warn("No department items selected for saving.");
        this.isProgressing = false;
      }
    }
    newfnpipeactionReadlog()
          {
             const pmsCodesCsv = this.selectedDeptItems.map(item => item.pmscode).join(',');
      console.log("comma pmscode", pmsCodesCsv);
            console.log("usrid",this.Userid);
            this.isProgressing = true;
          this.apiCallIdsService.newfnpipeactionloadreadsave
          (pmsCodesCsv,this.selectedAction,'','',"Read")
            .subscribe(
              data => {
                console.log('New Screen Data Log Read', data)
                this.dataSource = data;
                this.hotellistproperty = this.apiresult;
                this.dropdownDeptData = this.apiresult;
                this.isProgressing = false;
                this.displayContent = true
              });
          }
          updateSaveButtonStatus() {
            this.addBtnDisabledFunc = !(this.selectedDeptItems.length > 0 && this.selectedAction);
          }
      heartbeatFunction() {
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat
          });
      }

      GetParseonlyDateTime(d: any) {
        console.log('GetParseonlyDateTime call', d.substring(12))
        return (d.substring(12));
      }
      onPmsCodeChange(event: any): void {
        this.isSaveEnabled = this.selectedDeptItems.length > 0; // Enable Save if an item is selected
      } 
    
}
